import React from 'react';

const SingleChooseTwo = (props) => {
  const { itemClass, icon, title } = props;
  return (
    <div className={itemClass ? itemClass : 'it-about-2-icon-box mb-20'}>
      <span>
        <i className={icon ? icon : 'flaticon-counseling'}></i>
      </span>
      <h5>{title ? title : 'Online Counseling'}</h5>
    </div>
  );
};

export default SingleChooseTwo;
